// generated from 1_122 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const localeFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("locale_filter"),
  comparison_key: z.enum([
    "10", // 614 (54.72%)
    "1", // 284 (25.31%)
    "17", // 184 (16.40%)
    "2", // 22 (1.96%)
    "11", // 10 (0.89%)
    "26", // 7 (0.62%)
    "25", // 1 (0.09%)
  ]),
  display_name: z.string(),
  // undefined: 342 (30.48%), defined 780 (69.52%)
  raw_value: z
    .union([
      // string samples: 772 (98.97%)
      z.string(),
      // array samples: 8 (1.03%)
      z.array(z.string()),
    ])
    .optional(),
  value: z.union([
    // string samples: 1_114 (99.29%)
    z.string(),
    // array samples: 8 (0.71%)
    z.array(z.string()),
  ]),
  varies_by_app_group: z.literal(false),
});
